/* eslint-disable prefer-template */
import Countryshow from "@/components/Countryshow";
import GetCoins from "@/components/GetCoins";
import NewGetCoins from "@/components/NewGetCoins";
import HomeGameContainer from "@/components/HomeGameContainer";
import HomeGameTabNav from "@/components/HomeGameTabNav";
import HomeHeader from "@/components/HomeHeader";
import HomeInviteWheelFloatBall from "@/components/HomeInviteWheelFloatBall";
import HomeTabNav2 from "@/components/HomeTabNav2";
import MyNavLink from "@/components/MyNavLink";
import Slides from "@/components/Slides";
import { LocalConfig, NumericalConfig, GamesConfig, SocialConfig, FunctionalConfig } from "@/config";
import { LocationInfo } from "@/data/LocationInfo";
import { PersistContext } from "@/data/PersistProvider";
import { RootStateContext } from "@/data/RootStateProvider";
import { LanguageContext } from "@/data/LanguageProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { GetGameUrl, GetDownloadApkUrl } from "@/data/urls";
import { SendEvent } from "@/utils/Analytics";
import { AppVersion, FromGameApp, FromInstalled, FromStandAlone } from "@/utils/BroswerHelper";
import { SendCMD } from "@/utils/HTTPRequest";
import { SinNumberGenerator } from "@/utils/JSTool";
import { ChannelRemind } from "@/utils/UrlHelper";
import React, { useEffect, useRef, useState, useContext } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Dialog, NoticeBar, Popup, Swiper, Toast } from "react-vant";
import style from "./style.less";
import DownloadFloatBall from "@/components/DownloadFloatBall";
import LuckyWheelDialog from "../WheelTotal";
const HomeTabList = [
  { name: "Home", link: "#" },
  { name: "League", link: "#" },
  { name: "Virtual", link: "#" },
  { name: "Freebet", link: "#" },
  { name: "App", link: "#" },
];

const BannerAds = {
  // wreath: { name: "invite", image: require("@/assets/images/home/index_banner_wreath.png").default, link: "/wreath" },
  // harvest: { name: "invite", image: LocalConfig.indexBannerHarvestImg, link: "/harvest" },
  //activity_deposit: { name: "activity_deposit", image: LocalConfig.indexBannerActivityImg, link: "/deposit" },
  first_deposit: { name: "first_deposit", image: LocalConfig.indexBannerDepositImg, link: "/deposit" },
  free_cash: { name: "free_cash", image: LocalConfig.indexBannerFreeCashImg, link: "/FreeCash" },
  luck_draw: { name: "luck_draw", image: LocalConfig.indexBannerDrawImg, link: "/luckyDraw" },
  invite_wheel: {
    name: "invite_wheel",
    image: LocalConfig.indexBannerLuckyWheelImg,
    link: "/inviteWheel",
  },
  leader: { name: "leader", image: LocalConfig.indexBannerLeaderImg, link: "/leader" },
  invite: { name: "invite", image: LocalConfig.indexBannerinviteImg, link: "/invite" },
  install: { name: "install", image: LocalConfig.indexBannerInstallImg, link: "/downloadApp" },
  every_deposit: { name: "every_deposit", image: LocalConfig.indexBannerDeposit2Img, link: "/deposit" },
  withdraw: { name: "withdraw", image: LocalConfig.indexBannerWithdrawalImg, link: "/withdraw" },
};

const NowTimestamp = Date.now();

const OnlineNumberGenerator = (seed, online_level) => {
  switch (online_level) {
    case 0:
      return (SinNumberGenerator(((NowTimestamp / 1000) % 1000) / 500 / Math.PI, seed / 10) * 700 + Math.floor(Math.random() * (30000 - 20000 + 1)) + 20000).toFixed(0);
    case 1:
      return (SinNumberGenerator(((NowTimestamp / 1000) % 1000) / 500 / Math.PI, seed / 10) * 700 + Math.floor(Math.random() * (12000 - 8000 + 1)) + 8000).toFixed(0);
    case 2:
      return (SinNumberGenerator(((NowTimestamp / 1000) % 1000) / 500 / Math.PI, seed / 10) * 700 + Math.floor(Math.random() * (7000 - 2000 + 1)) + 2000).toFixed(0);
    default:
      return (SinNumberGenerator(((NowTimestamp / 1000) % 1000) / 500 / Math.PI, seed / 10) * 700 + Math.floor(Math.random() * (2000 - 1000 + 1)) + 1000).toFixed(0);
  }
};

const JackpotNumberGenerator = (seed, from, to) => {
  return (SinNumberGenerator(((NowTimestamp / 1000) % 1000) / 500 / Math.PI, seed) * (to - from) + from).toLocaleString(
    "en-US",
    { maximumFractionDigits: 0 }
  );
};

const game2Url = GetGameUrl(2);
const game3Url = GetGameUrl(3);
const game5Url = GetGameUrl(5);

const games = {};
GamesConfig.games.map((game) => {
  let tmpGame = Object.assign({}, game);
  if (tmpGame.jackpot_from_to) {
    tmpGame.jackpot = JackpotNumberGenerator(tmpGame.id, tmpGame.jackpot_from_to[0], tmpGame.jackpot_from_to[1]);
  }
  // tmpGame.img = `/assets/images/` + tmpGame.img;
  tmpGame.img = require(`@/assets/images/${tmpGame.img}`).default;
  let baseUrl = game3Url;
  if (tmpGame.type == 2) {
    baseUrl = game2Url;
  } else if (tmpGame.type == 5) {
    baseUrl = game5Url;
  }
  tmpGame.url = baseUrl + tmpGame.query;
  tmpGame.online = OnlineNumberGenerator(tmpGame.id, tmpGame.online_level);
  games[game.id] = tmpGame;
});
console.log("games", games);

// const games_originals = [];
// GamesConfig.games_originals.map((gameid) => {
//   games_originals.push(games[gameid]);
// });
// const games_originals_b = [];
// GamesConfig.games_originals_b.map((gameid) => {
//   games_originals_b.push(games[gameid]);
// });
const games_popular = [];
GamesConfig.games_popular.map((gameid) => {
  games_popular.push(games[gameid]);
});
const games_popular_b = [];
GamesConfig.games_popular_b.map((gameid) => {
  games_popular_b.push(games[gameid]);
});
const games_spin = [];
GamesConfig.games_spin.map((gameid) => {
  games_spin.push(games[gameid]);
});
const games_slots = [];
GamesConfig.games_slots.map((gameid) => {
  games_slots.push(games[gameid]);
});
const games_football = [];
GamesConfig.games_football.map((gameid) => {
  games_football.push(games[gameid]);
});
const games_table_games = [];
GamesConfig.games_table_games.map((gameid) => {
  games_table_games.push(games[gameid]);
});
const games_instant_games = [];
GamesConfig.games_instant_games.map((gameid) => {
  games_instant_games.push(games[gameid]);
});

const MarqueeGenerator = (count) => {
  // return [
  //   {
  //     phone: "",
  //     content:
  //       "Server maintenance on September 8th, 5:00-7:00 AM. Services will be interrupted. Apologies for the inconvenience.",
  //   },
  // ];
  let { langText } = useContext(LanguageContext);
  let gameKeys = Object.keys(games);
  let marqueeList = [];
  for (let i = 0; i < count; i++) {
    // let amount = (SinNumberGenerator(((NowTimestamp / 100000) % 100000) / 50000 / Math.PI, seed+i / 10) * 700 + 200).toFixed(0);
    let amount = (
      SinNumberGenerator(((NowTimestamp / 100000) % 100000) / 50000 / Math.PI, i) * (100000 - 10000) +
      10000
    ).toFixed(0);
    let phone = (
      SinNumberGenerator(((NowTimestamp / 100000) % 100000) / 50000 / Math.PI, i) * (99999 - 1000) +
      1000
    ).toFixed(0);

    if (phone.length < 5) {
      phone = `0${phone}`;
    }
    phone = `${phone.substring(0, 1)}****${phone.substring(2, 5)}`;

    let gameIndex = Math.floor(
      SinNumberGenerator(((NowTimestamp / 100000) % 100000) / 50000 / Math.PI, i) * (gameKeys.length - 1 - 0) + 0
    );
    console.log("gameKeys.length", gameKeys.length);
    let random = Math.random()
    let content = ""
    content = langText("home_tips_notify", { param1: phone, param2: amount, param3: games[gameKeys[gameIndex]].name });
    if (random > 0.5) {//显示的是提款
      let randomValue = Math.floor(Math.random() * 9000) + 1000
      content = langText("home_tips_notify_2", { param1: phone, param2: randomValue });
    }
    marqueeList.push({
      content: content
    });
  }
  return marqueeList;
};

const Home = () => {
  const containerRef = React.useRef(null);
  const pageScrolledRef = React.useRef(false);
  const { getPersist, setPersist } = React.useContext(PersistContext);
  const { rootState, setRootStateKey } = React.useContext(RootStateContext);
  const { getLanguage, langText, langImg } = React.useContext(LanguageContext);
  const history = useEnhancedHistory();
  const [downloadTipClosed, setDownloadTipClosed] = useState(true);
  const [homeScreenTipClosed, sethomeScreenTipClosed] = useState(true);
  // const [whatsApp, setWhatsApp] = useState("85253053474");
  // 联系我们
  const [contactType, setContactType] = useState("WhatsApp");
  const [contactNumber, setContactNumber] = useState("85253053474");
  const [contactCopy, setContactCopy] = useState("85253053474");
  // 联系我们
  const [contactType2, setContactType2] = useState("");
  const [contactNumber2, setContactNumber2] = useState("");
  const [contactCopy2, setContactCopy2] = useState("");
  // 合作
  const [partnerText, setPartnerText] = useState("Partners");
  const [partnerMail, setPartnerMail] = useState("partners");
  //跑马灯
  const [marquee, setMarquee] = useState(MarqueeGenerator(3));
  const [bannerAds, setBannerAds] = useState(BannerAds);
  //更新提示
  const [showUpdate, setShowUpdate] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(false);
  //排行榜数据
  const [rankReward, setRankReward] = useState({})

  //每次到首页时重置登录页面状态
  setPersist("isLogin", false);
  useEffect(() => {
    if (getPersist("login_back_url")) {
      setPersist("login_back_url", null);
    }
  }, []);
  useEffect(() => {
    if (getPersist("dataLoaded")) {
      let channel = getPersist("channel");
      if (["yfb4", "yfb3yd1"].indexOf(channel) > -1) {
        setPersist("downloadTipClosed", true);
        setDownloadTipClosed(true);
      }
      setDownloadTipClosed(getPersist("downloadTipClosed"));
    }
  }, [getPersist("dataLoaded"), getPersist("channel"), getPersist("downloadTipClosed")]);
  useEffect(() => {
    let bgSettings = getPersist("bgSettings");
    let closeMarqueeTimer = null;
    if (bgSettings && bgSettings.marquee && bgSettings.marquee.info) {
      if (bgSettings.marquee.startTime < Date.now() / 1000 && bgSettings.marquee.endTime > Date.now() / 1000) {
        setMarquee([{ content: bgSettings.marquee.info }]);
        if (closeMarqueeTimer) {
          clearTimeout(closeMarqueeTimer);
        }
        closeMarqueeTimer = setTimeout(() => {
          setMarquee(MarqueeGenerator(3));
        }, bgSettings.marquee.endTime * 1000 - Date.now());
      }
    }
    // if (
    //   bgSettings &&
    //   bgSettings.settings &&
    //   bgSettings.settings.client_config &&
    //   bgSettings.settings.client_config.whatsapp
    // ) {
    //   setWhatsApp(bgSettings.settings.client_config.whatsapp);
    // }
    if (
      bgSettings &&
      bgSettings.settings &&
      bgSettings.settings.client_config
    ) {
      if (bgSettings.settings.client_config.contactType) {
        setContactType(bgSettings.settings.client_config.contactType);
      }
      if (bgSettings.settings.client_config.contactNumber) {
        setContactNumber(bgSettings.settings.client_config.contactNumber);
      }
      if (bgSettings.settings.client_config.contactCopy) {
        setContactCopy(bgSettings.settings.client_config.contactCopy);
      } else {
        setContactCopy(bgSettings.settings.client_config.contactNumber);
      }

      if (bgSettings.settings.client_config.contactType2) {
        setContactType2(bgSettings.settings.client_config.contactType2);
      }
      if (bgSettings.settings.client_config.contactNumber2) {
        setContactNumber2(bgSettings.settings.client_config.contactNumber2);
      }
      if (bgSettings.settings.client_config.contactCopy2) {
        setContactCopy2(bgSettings.settings.client_config.contactCopy2);
      } else {
        setContactCopy2(bgSettings.settings.client_config.contactNumber2);
      }

      if (bgSettings.settings.client_config.partnerText) {
        setPartnerText(bgSettings.settings.client_config.partnerText);
      }
      if (bgSettings.settings.client_config.partnerMail) {
        setPartnerMail(bgSettings.settings.client_config.partnerMail);
      }
    }
    return () => {
      if (closeMarqueeTimer) {
        clearTimeout(closeMarqueeTimer);
        closeMarqueeTimer = null;
      }
    };
  }, [getPersist("bgSettings")]);
  // document.write(navigator.userAgent)
  const homeTabMarginTop = downloadTipClosed ? "3.8rem" : "7rem";
  const topAreaHeight = downloadTipClosed ? "9.5rem" : "12.6rem"; // 12 8 3.5
  const [showingLayerGame, setShowPlayGameLayer] = React.useState(null);
  const onWillPlayGame = (game) => {
    SendEvent("game_entrance_click", { game_id: game.id });
    setShowPlayGameLayer(game);
  };
  const userInfo = getPersist("user_info");

  console.log("userInfo", userInfo);
  /**
   * 首页弹窗规则
   * 1. 如果用户没有登录，弹出首充，但是按钮显示注册
   * 2. 如果用户登录了，但是没有首充，弹出首充，按钮显示存款
   * 3. 如果用户登录了，首充了，弹出无限代活动，无限代活动每天只弹一次
   *
   *
   */
  //首冲广告弹框
  const [depositNowDiaLogVisible, setDepositNowDiaLogVisible] = useState(0);
  // FreeCash广告弹框
  const [freecashDialogVisible, setFreecashDialogVisible] = useState(false);

  // 用户优惠充值弹窗
  const [depositActivityDiaLogVisible, setDepositActivityDiaLogVisible] = useState(0);
  const [depositActivityData, setDepositActivityData] = useState({});

  //限时活动只有充值后才不弹出
  const [limitDiscountsDiaLogVisible, setLimitDiscountsDiaLogVisible] = useState(false);


  //点击DEPOSIT NOW按钮事件
  const onDepositNowClick = () => {
    //隐藏首冲弹框
    setDepositNowDiaLogVisible(false);
    if (depositNowDiaLogVisible == 1) {
      setRootStateKey("depositPromotionOpenTime", 0);
      SendEvent("pupop_reister_ad_click", { signed_in: !!userInfo });
      //跳转到注册页面
      history.push(ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1"}`));
      return;
    }
    SendEvent("pupop_deposit_ad_click", { signed_in: !!userInfo });
    //跳转到充值页面
    history.push(ChannelRemind("./deposit"));
  };

  //点击DEPOSIT NOW Activity按钮事件
  const onDepositActivityClick = () => {
    //隐藏用户优惠充值弹框
    setDepositActivityDiaLogVisible(false);
    if (depositActivityDiaLogVisible == 1) {
      //跳转到注册页面
      history.push(ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1"}`));
      return;
    }
    //跳转到充值页面
    history.push(ChannelRemind("./deposit?deposit_now=" + (NumericalConfig.limitDiscounts / 100).toFixed(0)));
  };

  //无限代活动弹框
  const [referFriendsDiaLogVisible, setReferFriendsDiaLogVisible] = useState(false);
  //点击REFER FRIENDS按钮事件
  const OnReferFriendsClick = () => {
    SendEvent("pupop_invite_ad_click", { signed_in: !!userInfo });
    //隐藏无限代活动弹框
    setReferFriendsDiaLogVisible(false);
    //跳转 要求好友活动界面
    history.push(ChannelRemind("./invite"));
  };

  //Get Coins弹框
  const [coinsDiaLogVisible, setCoinsDiaLogVisible] = useState(0);
  //New Get Coins弹框
  const [newCoinsDiaLogVisible, setNewCoinsDiaLogVisible] = useState(0);

  // 排行榜弹框
  const [rankDialogVisible, setRankDialogVisible] = useState(false);

  //是否显示免费转盘弹框
  const [inviteWheelCanvasDiaLogVisible, setInviteWheelCanvasDiaLogVisible] = useState(false);
  const [floatBall, setFloatBall] = useState(true);
  const [downloadFloatBall, setDownloadFloatBall] = useState(false);

  const deferredPrompt = useRef(null);

  const bindBeforeinstallprompt = (e) => {
    console.log("bindBeforeinstallprompt loaded", e);
    console.log("FromInstalled", FromInstalled);
    e.preventDefault();
    deferredPrompt.current = e;
    sethomeScreenTipClosed(FromInstalled);
  };

  //获取是否首冲
  useEffect(() => {
    SendEvent("home_loaded", {});
    //判断是不是App，需不需要更新，需要的话直接弹出更新提示，其他都不弹出了
    console.log("FromGameApp", FromGameApp);
    console.log("AppVersion", AppVersion);
    console.log("forceUpdateToVersion", LocalConfig.forceUpdateToVersion);
    console.log("DownloadApkUrl", GetDownloadApkUrl(getPersist("channel") ? getPersist("channel") : ""));
    if (FromGameApp && AppVersion < LocalConfig.appVersion) {
      setShowUpdate(true);
      if (AppVersion < LocalConfig.forceUpdateToVersion) {
        setForceUpdate(true);
      }
      return;
    }
    if (!getPersist("user_info")) {
      //如果用户没有登录，弹出首充，但是按钮显示注册,每天弹一次
      let day = localStorage.getItem('depositNowDiaLog')
      if (new Date().getDay() != day) {
        //首冲广告弹框
        setDepositNowDiaLogVisible(1);
        setRootStateKey("depositPromotionOpenTime", Date.now());
        localStorage.setItem('depositNowDiaLog', new Date().getDay())
      }
      // 如果没有登录，先弹出活动弹窗
      if (getPersist("recall_act_open")) {
        setDepositActivityDiaLogVisible(1);
      } else {
        bannerAds.activity_deposit = null;
        delete bannerAds.activity_deposit;
      }

      //如果用户没有登录，弹出免费转盘弹框
      setInviteWheelCanvasDiaLogVisible(true);

      //如果用户没登录，首充广告跳转到注册页面
      if (bannerAds.first_deposit) {
        bannerAds.first_deposit.link = ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1&"}`);
        setBannerAds(Object.assign({}, bannerAds));
      }

      //如果用户没有登录，不显示下载广告
      // bannerAds.install.hide = true;
    } else {
      //如果用户已经登录，首充广告跳转到充值页面
      if (bannerAds.first_deposit) {
        bannerAds.first_deposit.link = "/deposit";
        setBannerAds(Object.assign({}, bannerAds));
      }

      //如果用户已经登录，恢复下载广告
      // bannerAds.install.hide = false;

      //获取充值级别相关数据
      //getRechargeLevels();
      setFloatBall(true);
    }
    //没有登陆时也要获取数据
    getRechargeLevels();
    //赞比亚用户的充值广告上面要增加文字，所以只能使用Node而非图片
    console.log("LocalConfig.locationKey", LocalConfig.locationKey);
    if (LocalConfig.locationKey == "ZM" && bannerAds.first_deposit || LocalConfig.locationKey == "UG2" && bannerAds.first_deposit) {
      bannerAds.first_deposit.node = (
        <>
          <img src={langImg(LocalConfig.indexBannerDepositImg)} alt="" style={{ width: "100%", height: "100%" }} loading="lazy" />
          <div class={style.deposit_banner_ad_container} style={LocalConfig.locationKey == "UG2" && getLanguage() == "bem" && { marginLeft: "3.7rem" } || LocalConfig.locationKey == "UG2" && { marginLeft: "2rem" }}>
            <div class={style.top_up_value} style={LocalConfig.locationKey == "UG2" && { marginLeft: "-0.2rem", marginTop: "0.2rem" }}>
              <div style={getLanguage() == "bem" && { fontSize: "1.7rem" }}>{NumericalConfig.firstRechargeAmount / 100}</div>
            </div>
            <div class={style.extral_value} style={LocalConfig.locationKey == "UG2" && { fontSize: "2.1rem", marginTop: "0.2rem" }}>
              <span style={getLanguage() == "bem" && { fontSize: "1.6rem", marginRight: "1.8rem" }}>{(NumericalConfig.firstRechargeAmount * NumericalConfig.firstRechargeBonusRate) / 100}</span>
            </div>
          </div>
        </>
      );
      setBannerAds(Object.assign({}, bannerAds));
    }
    //监听添加到主屏幕是否可用
    if (window && !deferredPrompt.current) {
      console.log("bindBeforeinstallprompt listen");
      window.addEventListener("beforeinstallprompt", bindBeforeinstallprompt);
    }
    //判断要不要显示安装广告
    console.log("FromStandAlone:", FromStandAlone)
    if (FromInstalled) {
      bannerAds.install.hide = true;
      setBannerAds(Object.assign({}, bannerAds));
    } else {
      setDownloadFloatBall(true);
    }
    return () => {
      if (window && deferredPrompt.current) {
        deferredPrompt.current = null;
        window.removeEventListener("beforeinstallprompt", bindBeforeinstallprompt);
      }
    };
  }, []);
  const getRechargeLevels = () => {
    //请求参数判断： 是否游客
    let data = {};
    if (userInfo) {
      data = { token: userInfo.token };
    }

    SendCMD("getRechargeLevels", data).then((res) => {
      if (!res.status) {
        console.log(res.errdesc);
      } else if (res.first_recharge_bonus) {
        if (Date.now() - rootState.depositPromotionOpenTime > 3600000) {
          //首冲广告弹框
          setDepositNowDiaLogVisible(2);
          setRootStateKey("depositPromotionOpenTime", Date.now());
        }
      } else {
        bannerAds.first_deposit = null;
        delete bannerAds.first_deposit;
        setBannerAds(Object.assign({}, bannerAds));

      }
      if (userInfo && getPersist("invitePromotionOpenDay") != new Date().getDay()) {
        //无限代活动弹框
        setReferFriendsDiaLogVisible(true);
        setPersist("invitePromotionOpenDay", new Date().getDay());
      }
      // 每次进入大厅时更新用户金币余额
      if (res.status && res.money) {
        let tempUserInfo = getPersist("user_info");
        tempUserInfo.money = res.money;
        setPersist("user_info", tempUserInfo);
      }

      //限时活动只有充值后才不弹出
      setLimitDiscountsDiaLogVisible(res.recall_act_open)
      if (res.status && res.recall_act_open && res.recall_act_now && res.recall_act_end_time && res.recall_act_now < res.recall_act_end_time) {
        //充值活动弹框
        setDepositActivityDiaLogVisible(2);
        // 获取本地时间与服务器时间偏移值，通过偏移值计算本地活动结束时间
        let offsetTime = res.recall_act_now - Math.floor(Date.now() / 1000)
        let endTime = res.recall_act_end_time - offsetTime
        setDepositActivityData({
          endTime: endTime,
          client_show_time: res.client_show_time,
        })
      } else {
        bannerAds.activity_deposit = null;
        delete bannerAds.activity_deposit;
        setBannerAds(Object.assign({}, bannerAds));
      }
      if (getPersist("user_info")) {
        //如果今天没有弹过的话，自动弹出,由于会受其它活动的影响，所以写在最后
        if (getPersist("freecashPopupDay") != new Date().getDay()) {
          setFreecashDialogVisible(true);
        }
      }
    });
    
    SendCMD("rankGetRewardInfo", data).then((res) => {
      if (!res.status) {
        console.log(res.errdesc);
      } else {
        let info = res.info;
        if (!info || Object.keys(info).length === 0) {
          setRankDialogVisible(false)
        } else {
          setRankDialogVisible(true)
          for (let i = 0; i < info.length; i++) {
            if (info[i].create_time) {
              const date = new Date(info[i].create_time);
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const day = String(date.getDate()).padStart(2, '0');

              const formattedDate = `${year}/${month}/${day}`;
              info[i].date = formattedDate;
            }
            if (info[i].ranktype == "rank_daily") {
              info[i].type = "Daily";
            } else if (info[i].ranktype == "rank_week") {
              info[i].type = "Weekly";
            } else if (info[i].ranktype == "rank_new_player") {
              info[i].type = "Newbie";
            }
          }
          setRankReward(info)
        }
        console.log("rankGetInfo", info);
      }
    });
  };

  const GameLayer = ({ game }) => {
    if (!game) return null;
    let fullGameUrl = ChannelRemind(`/game?game_id=${game.id}&url=${encodeURI(game.url)}`);
    if (!userInfo) {
      fullGameUrl = ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1"}`);
    }

    const onFullGameClick = () => {
      SendEvent("game_play_click", { game_id: game.id });
      if (game.type == 20) {
        if (!userInfo) {
          history.push(ChannelRemind("/login"));
          return;
        }
        //吉利游戏API，请求后台获得游戏链接后跳转
        SendCMD("jiliLoginRedirect", {
          gameId: game.jiliInfo.gameId,
          lang: "en-US",
          homeUrl: location.href,
          token: userInfo.token,
        }).then((res) => {
          if (!res.redirectUrl) {
            Toast.fail({
              message: "Game under maintenance, try again later!",
            });
          } else {
            console.error("redirectUrl:", redirectUrl)
            location.href = res.redirectUrl;
          }
        });
      } else {
        if (!userInfo) {
          setPersist("login_back_url", fullGameUrl);
        }
        console.error("fullGameUrl:", fullGameUrl)
        history.push(fullGameUrl);
      }
    };
    return (
      <div class={style.playContent}>
        <img src={game.img} alt="" loading="lazy" />
        <div class={style.gameInfo}>
          <div class={style.gameName}>{game.name}</div>
          <div class={style.gameDesc}>
            {game.hide_demo
              ? null
              : langText("home_tips_slots")}
          </div>
          <div class={style.gameBtns}>
            <MyNavLink
              to={ChannelRemind(`/game?game_id=${game.id}&demo=1&url=${encodeURI(game.url)}`)}
              onClick={() => SendEvent("game_demo_click", { game_id: game.id })}
              style={game.hide_demo ? { display: "none" } : {}}
            >
              <span class={style.gameBtnDemo} style={getLanguage() == "bem" && { fontSize: "0.8rem" }}>{langText("home_btn_demo")}</span>
            </MyNavLink>
            <span class={style.gameBtnMode} onClick={onFullGameClick} style={getLanguage() == "bem" ? { fontSize: "0.8rem", lineHeight: "-1rem" } : { lineHeight: "2.34rem" }}>
              <p style={getLanguage() == "bem" && { marginTop: "0.3rem" }}>{langText("home_btn_playnow")}</p>
            </span>
          </div>
        </div>
      </div>
    );
  };
  const OnTabChange = (index) => {
    console.log("OnTabChange", index);
    switch (index) {
      case 1:
        setCoinsDiaLogVisible(true);
        break;
      case 2:
        setNewCoinsDiaLogVisible(true);
        break;
      // case 2:
      //   if (!slotsRef.current || !containerRef.current) return;
      //   containerRef.current.scrollTop = slotsRef.current.offsetTop - 40 - (downloadTipClosed ? 0 : 50);
      //   break;
      // case 3:
      //   if (!footballRef.current || !containerRef.current) return;
      //   containerRef.current.scrollTop = footballRef.current.offsetTop - 40 - (downloadTipClosed ? 0 : 50);
      //   break;
    }
  };

  const AddToHomeScreen = () => {
    SendEvent("add_home_screen", {});
    if (!deferredPrompt.current) {
      sethomeScreenTipClosed(true);
      console.log("deferredPrompt.current is null");
      SendEvent("add_home_screen_result", { result: "error" });
      return;
    }
    deferredPrompt.current.prompt();
    deferredPrompt.current.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        sethomeScreenTipClosed(true);
        SendEvent("add_home_screen_result", { result: "accepted" });
        console.log("User accepted the install prompt");
      } else {
        SendEvent("add_home_screen_result", { result: "rejected" });
        console.log("User dismissed the install prompt");
      }
    });
  };

  const [nowShowingIndex, setNowShowingIndex] = useState(0);

  const OnGameTabChange = (index) => {
    console.log("OnGameTabChange", index);
    setNowShowingIndex(index);
  };

  const getHomeGameContainer = (index) => {
    switch (index) {
      case 0:
        return (
          <>
            {/* <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_originsals2.png").default}
              name={langText("home_bookmark_1")}
              // games={getPersist("abtest_tag") == "t8:g2" ? games_originals_b : games_originals}
              games={games_originals_b}
              onGameClick={onWillPlayGame}
            /> */}
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_popular2.png").default}
              name={langText("home_bookmark_2")}
              games={games_popular_b}
              onGameClick={onWillPlayGame}
            />
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_spin2.png").default}
              name={langText("home_bookmark_3")}
              games={games_spin}
              onGameClick={onWillPlayGame}
            />
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_slots2.png").default}
              name={langText("home_bookmark_4")}
              games={games_slots}
              onGameClick={onWillPlayGame}
            />
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_football2.png").default}
              name={langText("home_bookmark_5")}
              games={games_football}
              onGameClick={onWillPlayGame}
            />
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_tableGames2.png").default}
              name={langText("home_bookmark_6")}
              games={games_table_games}
              onGameClick={onWillPlayGame}
            />
            <HomeGameContainer
              icon={require("@/assets/images/home/class_icon/icon_instantGames2.png").default}
              name={langText("home_bookmark_7")}
              games={games_instant_games}
              onGameClick={onWillPlayGame}
            />
          </>
        );
      case 1:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_popular2.png").default}
            name={langText("home_bookmark_2")}
            games={games_popular}
            onGameClick={onWillPlayGame}
          />
        );
      case 2:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_spin2.png").default}
            name={langText("home_bookmark_3")}
            games={games_spin}
            onGameClick={onWillPlayGame}
          />
        );
      case 3:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_slots2.png").default}
            name={langText("home_bookmark_4")}
            games={games_slots}
            onGameClick={onWillPlayGame}
          />
        );
      case 4:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_football2.png").default}
            name={langText("home_bookmark_5")}
            games={games_football}
            onGameClick={onWillPlayGame}
          />
        );
      case 5:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_tableGames2.png").default}
            name={langText("home_bookmark_6")}
            games={games_table_games}
            onGameClick={onWillPlayGame}
          />
        );
      case 6:
        return (
          <HomeGameContainer
            icon={require("@/assets/images/home/class_icon/icon_instantGames2.png").default}
            name={langText("home_bookmark_7")}
            games={games_instant_games}
            onGameClick={onWillPlayGame}
          />
        );
    }
  };
  return (
    <div
      class={style.page_container}
      ref={containerRef}
      onScroll={() => {
        if (!pageScrolledRef.current) {
          pageScrolledRef.current = true;
          SendEvent("home_page_scrolled", {});
        }
      }}
    >
      <HomeHeader />
      {/* <LuckyWheelDialog
        visible={false}
      //  onClose={() => setShowWheel(false)}
      >
      </LuckyWheelDialog> */}
      <div class={style.main}>
        <div class={style.top} style={{ height: topAreaHeight }}>
          <div style={{ marginTop: homeTabMarginTop, paddingLeft: "0.5rem", paddingRight: "0.3rem" }}>
            <HomeTabNav2 activeIndex={0} list={HomeTabList} onTabChange={OnTabChange} />
          </div>
        </div>
        <div class={style.top_looping}>
          <Slides list={Object.values(bannerAds)} />
          <div class={style.marquee}>
            <img src={require("@/assets/icons/notification.svg").default} style={{ width: "1.25rem" }} loading="lazy" />
            <Swiper autoplay={7000} loop touchable={false} indicator={false} vertical style={{ height: "1.4rem" }}>
              {marquee.map((value, index) => (
                <Swiper.Item key={index}>
                  <NoticeBar
                    text={` ${value.content}`}
                    background="rgba(0,0,0,0)"
                    color="rgb(70,179,41)"
                    style={{
                      marginTop: "0.1rem",
                      "--rv-notice-bar-height": "20px",
                      "--rv-notice-bar-line-height": "14px",
                      color: "rgb(70,179,41)",
                      fontWeight: "700",
                      fontSize: "0.75rem",
                    }}
                  />
                </Swiper.Item>
              ))}
            </Swiper>
          </div>
        </div>

        <div class={style.home_game_tab_nav + " home_game_tab"}>
          <HomeGameTabNav activeIndex={0} onTabChange={OnGameTabChange} />
        </div>
        {getHomeGameContainer(nowShowingIndex)}

        <div class={style.footer}>
          <div class={style.footer_country_info}>
            <div class={style.footer_country_icon}>
              <div class={style.footer_country_icon1}>
                <img src={LocalConfig.icon} loading="lazy" />
              </div>
              <div class={style.footer_country_icon2}>
                <img src={LocalConfig.titleImgWhite} loading="lazy" />
              </div>
            </div>
            <div class={style.footer_country_intro}>{langText("home_advertising", { param1: LocalConfig.gameName })}</div>
            <div class={style.footer_country_select}>
              <Countryshow from="Home" />
            </div>
          </div>
          <div class={style.footer_link}>
            <div class={style.link}>
              <MyNavLink to="/about" style={{ border: "0px", paddingRight: "0.6rem", paddingLeft: "0.6rem" }}>
                <div class={style.link_span}>
                  <span>{langText("home_btn_about")}</span>
                </div>
              </MyNavLink>
              <MyNavLink to="/contact">
                <div class={`${style.link_span} ${style.link_us}`}>
                  <span>{langText("home_btn_contact")}</span>
                </div>
              </MyNavLink>
              <MyNavLink to="/help">
                <div class={style.link_span}>
                  <span>{langText("home_btn_howToPlay")}</span>
                </div>
              </MyNavLink>
            </div>
            <div class={style.home_service}>
              <div class={style.home_service_img}>
                <img src={require("@/assets/images/home/kftb_1.png").default} loading="lazy" />
              </div>
              <div class={style.home_service_intro}>
                {contactType}
                {": "}
                {FunctionalConfig.CustomerContactClickable ? (
                  <a
                    href={contactCopy}
                    style={{ textDecoration: "underline", marginLeft: "0.5rem" }}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {contactNumber}
                  </a>
                ) : (
                  contactNumber
                )}
                {FunctionalConfig.CustomerContactCopyable && (
                  <CopyToClipboard
                    text={contactCopy}
                    onCopy={() => {
                      Toast.success({
                        message: "Copy Successfully",
                      });
                    }}
                  >
                    <img
                      style={{ width: "1rem", height: "1rem", margin: "0 0 0 .5rem" }}
                      src={require("@/assets/icons/copy.png").default}
                      loading="lazy"
                    />
                  </CopyToClipboard>
                )}
              </div>
              {contactType2 != "" && contactNumber2 != "" && (
                <div class={style.home_service_intro}>
                  {contactType2}
                  {": "}
                  {FunctionalConfig.CustomerContactClickable ? (
                    <a
                      href={contactCopy2}
                      style={{ textDecoration: "underline", marginLeft: "0.5rem" }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {contactNumber2}
                    </a>
                  ) : (
                    contactNumber2
                  )}
                  {FunctionalConfig.CustomerContactCopyable && (
                    <CopyToClipboard
                      text={contactCopy2}
                      onCopy={() => {
                        Toast.success({
                          message: "Copy Successfully",
                        });
                      }}
                    >
                      <img
                        style={{ width: "1rem", height: "1rem", margin: "0 0 0 .5rem" }}
                        src={require("@/assets/icons/copy.png").default}
                        loading="lazy"
                      />
                    </CopyToClipboard>
                  )}
                </div>
              )}
            </div>
            <div class={style.share}>
              <div class={style.add_customer_service}>
                {langText("home_tips_1", { param1: 11 })}
              </div>
            </div>
            <div class={style.share}>
              <div class={style.share_intro}>
                {langText("home_tips_connect", { param1: LocalConfig.gameName })}
              </div>
              <div class={style.share_type}>
                <MyNavLink to={`https://wa.me/${contactNumber}`} target="_blank" rel="noreferrer">
                  <img src={require("@/assets/icons/share5.svg").default} style={{ width: "2.5rem" }} loading="lazy" />
                </MyNavLink>
                <MyNavLink to={SocialConfig.facebook} target="_blank" rel="noreferrer">
                  <img src={require("@/assets/icons/share3.svg").default} style={{ width: "2.5rem" }} loading="lazy" />
                </MyNavLink>
                <MyNavLink to={SocialConfig.x} target="_blank" rel="noreferrer">
                  <img src={require("@/assets/icons/share2.svg").default} style={{ width: "2.5rem" }} loading="lazy" />
                </MyNavLink>
                <MyNavLink to={SocialConfig.instagram} target="_blank" rel="noreferrer">
                  <img src={require("@/assets/images/home/share1.png").default} style={{ width: "2.5rem" }} loading="lazy" />
                </MyNavLink>
              </div>
            </div>
          </div>
          <div class={style.terms}>
            <div class={style.terms_con}>
              <MyNavLink to="/termcond" style={{ textDecoration: "underline" }}>
                <span>{langText("home_btn_terms")}</span>
              </MyNavLink>
            </div>
            <div class={style.terms_pri_res}>
              <MyNavLink to="/privacy" style={{ textDecoration: "underline" }}>
                <span>{langText("home_btn_privacy")}</span>
              </MyNavLink>
              <MyNavLink to="/respgame" style={{ textDecoration: "underline" }}>
                {" "}
                <span>{langText("home_btn_responsible")}</span>
              </MyNavLink>
            </div>
          </div>

          <div class={style.licence}>
            <div class={style.licence_title}>
              <div class={style.licence_circle} />
              <div>{langText("home_tips_licence")}</div>
              <div class={style.licence_circle} />
            </div>
            <div class={style.licence_intro}>
              {langText("home_tips_introduction", { param1: LocalConfig.gameName, param2: LocationInfo().name })}
            </div>
          </div>
          <div class={style.partner_email}>
            <MyNavLink to={"mailto:" + partnerMail}>
              <span>{partnerText}</span>
              <span>{partnerMail}</span>
            </MyNavLink>
          </div>
        </div>
      </div>
      <Popup
        visible={showingLayerGame != null}
        style={{ backgroundColor: "#1c1c1c" }}
        position="bottom"
        closeOnClickOverlay={true}
        closeable={true}
        onClose={() => setShowPlayGameLayer(null)}
        destroyOnClose={true}
        transition="rv-fade"
      >
        <GameLayer game={showingLayerGame} />
      </Popup>
      <Popup
        visible={!homeScreenTipClosed}
        style={{ backgroundColor: "#1c1c1c" }}
        position="bottom"
        closeOnClickOverlay={true}
        closeable={false}
        onClose={() => sethomeScreenTipClosed(true)}
        destroyOnClose={true}
        transition="rv-fade"
      >
        <div class={style.addFavContent}>
          <div class={style.addFavTitle}>
            <img src={LocalConfig.appIcon64} loading="lazy" />
            <div style={{ flex: 1, color: "#ccc" }}>
              <p>Add {LocalConfig.gameName} to your HomeScreen for a better experience.</p>
              <p>
                And get{" "}
                <span style={{ color: "orange" }}>
                  {NumericalConfig.addHomeScreenRewardFrom}~{NumericalConfig.addHomeScreenRewardTo}{" "}
                  {LocalConfig.currencyCode} bonus
                </span>
                .
              </p>
            </div>
          </div>
          <div class={style.addFavButton}>
            <div class={style.addFavCancelButton} onClick={() => sethomeScreenTipClosed(true)}>
              {langText("withdraw_btn_2")}
            </div>
            <div class={style.addFavOkButton} onClick={AddToHomeScreen}>
              {langText("withdraw_btn_5")}
            </div>
          </div>
        </div>
      </Popup>
      <Dialog
        closeable={true}
        width={"95%"}
        closeOnClickOverlay={true}
        // closeIcon={<Close />}
        visible={depositNowDiaLogVisible != 0 && !depositActivityDiaLogVisible}
        showCancelButton={false}
        className={style.depositNowDialog}
        showConfirmButton={false}
        onClose={() => {
          if (depositNowDiaLogVisible == 1) {
            SendEvent("pupop_reister_ad_close", { signed_in: !!userInfo });
          } else {
            SendEvent("pupop_deposit_ad_close", { signed_in: !!userInfo });
          }
          setDepositNowDiaLogVisible(false);
        }}
      >
        <div
          style={{
            textAlign: "center",
            height: "auto",
            width: "100%",
            maxHeight: "35rem",
            marginTop: "1rem"
          }}
        >
          <img style={{ width: "110%", height: "auto", maxHeight: "35rem", marginLeft: "-5%" }} src={langImg("popup_bonus_pk")} loading="lazy" />
          <div onClick={onDepositNowClick}>
            <span>
              {depositNowDiaLogVisible == 1 ? (
                <img
                  style={{ width: "36%", height: "8%", marginTop: "-28%", marginLeft: "45%" }}
                  src={langImg("anniu1")}
                  loading="lazy"
                />
              ) : (
                <img
                  style={{ width: "36%", height: "8%", marginTop: "-28%", marginLeft: "45%" }}
                  src={langImg("anniu2")}
                  loading="lazy"
                />
              )}
            </span>
          </div>
        </div>
      </Dialog>
      {FunctionalConfig.newPromotion ? (
        <NewGetCoins newCoinsDiaLogVisible={newCoinsDiaLogVisible} setNewCoinsDiaLogVisible={setNewCoinsDiaLogVisible} />
      ) : (
        <GetCoins coinsDiaLogVisible={coinsDiaLogVisible} setCoinsDiaLogVisible={setCoinsDiaLogVisible} />
      )}

      {/* <HomeInviteWheelCanvasDialog
        setFloatBall={setFloatBall}
        inviteWheelCanvasDiaLogVisible={inviteWheelCanvasDiaLogVisible}
        setInviteWheelCanvasDiaLogVisible={setInviteWheelCanvasDiaLogVisible}
      /> */}

      <HomeInviteWheelFloatBall floatBall={floatBall} />
      <DownloadFloatBall floatBall={downloadFloatBall} onClose={() => setDownloadFloatBall(false)} />

      <Dialog
        closeable={true}
        width={"95%"}
        closeOnClickOverlay={true}
        visible={referFriendsDiaLogVisible && !depositActivityDiaLogVisible && !depositNowDiaLogVisible}
        showCancelButton={false}
        className={style.referFriendDialog} // 弹框背景色
        showConfirmButton={false}
        onClose={() => {
          SendEvent("pupop_invite_ad_close", { signed_in: !!userInfo });
          setReferFriendsDiaLogVisible(false);
        }}
      >
        <div
          style={{
            textAlign: "center",
            height: "auto",
            width: "100%",
            maxHeight: "35rem",
            marginTop: "1rem"
          }}
        >
          <img style={{ width: "100%", height: "auto", maxHeight: "35rem" }} src={langImg("ing_2")} />
          <img
            style={{ width: "36%", height: "8%", marginTop: "-32%", marginLeft: "45%" }}
            src={langImg("ing_3")}
            onClick={OnReferFriendsClick}
            loading="lazy"
          />
        </div>
      </Dialog>

      <Dialog
        closeable={true}
        width={"100%"}
        closeOnClickOverlay={true}
        visible={freecashDialogVisible && !depositActivityDiaLogVisible && !depositNowDiaLogVisible && !referFriendsDiaLogVisible}
        showCancelButton={false}
        className={style.referFriendDialog} // 弹框背景色
        showConfirmButton={false}
        onClose={() => {
          setPersist("freecashPopupDay", new Date().getDay());
          setFreecashDialogVisible(false);
        }}
      >
        <img
          style={{ width: "100%", height: "auto", marginLeft: "0%" }}
          src={langImg(LocalConfig.freeCashPopup)}
          onClick={() => {
            setPersist("freecashPopupDay", new Date().getDay());
            history.push(ChannelRemind("./FreeCash"));
          }}
        />
      </Dialog>

      <Dialog
        // closeable={true}
        width={"100%"}
        closeOnClickOverlay={true}
        visible={rankDialogVisible && !freecashDialogVisible && !depositActivityDiaLogVisible && !depositNowDiaLogVisible && !referFriendsDiaLogVisible}
        showCancelButton={false}
        className={style.referFriendDialog} // 弹框背景色
        showConfirmButton={false}
        onClose={() => {
          setPersist("freecashPopupDay", new Date().getDay());
          if (rankReward.length > 0) {
            const newRewards = [...rankReward];
            newRewards.shift();
            setRankReward(newRewards);
            if (newRewards.length == 0) {
              setRankDialogVisible(false);
            }
          }
        }}
      >
        <div style={{ position: "relative", width: "100%", height: "auto" }}>
          <img
            style={{ width: "100%", height: "auto" }}
            src={"../../assets/images/leaderboard/popup_bg.png"}
          />
          <div style={{
            position: "absolute",
            top: "35%",
            left: "10%",
            right: "10%",
            color: "white",
            fontSize: "18px",
            textAlign: "center",
            lineHeight: "1.7",
            fontWeight: "bold",
          }}>
            {rankReward[0] ? (
              <>
                You ranked {rankReward[0].rank}th in the {rankReward[0].type} Rankings on {rankReward[0].date}, and received 
                <span style={{ color: "rgb(255, 222, 0)" }}> {(rankReward[0].money / 100).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})} </span> 
                gold coins as a reward
              </>
            ) : (
              "Loading reward information..."
            )}
          </div>
        </div>
      </Dialog>

      <Dialog
        closeable={true}
        width={"95%"}
        closeOnClickOverlay={true}
        // closeIcon={<Close />}
        visible={limitDiscountsDiaLogVisible}
        showCancelButton={false}
        className={style.depositNowDialog_other}
        showConfirmButton={false}
        onClose={() => {
          setLimitDiscountsDiaLogVisible(false);
          setDepositActivityDiaLogVisible(false);
        }}
      >
        <div style={{
          textAlign: "centen",
          height: "30rem",
          background: `url(${langImg("popup_deposit_activity_bg")}) no-repeat 100%`,
          backgroundSize: "100%",
          backgroundPosition: "center",
          marginTop: "-2rem",
        }}>
          <div
            className={
              NumericalConfig.useWithdrawLevel > 0 ? style.firstDepositDialogBtnNew : style.firstDepositDialogBtn
            }
            onClick={onDepositActivityClick}
          >
            <div style={{
              marginTop: "-2.2rem",
              marginLeft: "8.5rem",
            }}>
              <span>
                <div style={{
                  width: "100%",
                  height: "0",
                }}>
                  <div style={{
                    position: "absolute",
                    transform: "translate(-2.5rem, -7.1rem)",
                    marginTop: "5.7rem",
                    fontSize: "0.73rem",
                    fontWeight: "bold",
                    color: "rgb(255, 227, 208)"
                  }}>
                    Event Time: {depositActivityData.client_show_time || getPersist("client_show_time")}
                  </div>
                </div>
                <div style={{
                  display: "grid",
                  placeItems: "center",
                  width: "9rem",
                  height: "2.7rem",
                  marginLeft: "-1rem",
                  marginTop: "29rem",
                  background: `url("../../assets/images/home/popup_deposit_activity_btn.png") no-repeat 100%`,
                  backgroundSize: "100%"
                }}>
                  <span style={{ fontWeight: "bolder", paddingBottom: "0.4rem", color: "rgb(255,255,255)" }} >{depositActivityDiaLogVisible == 1 ? langText("home_btn_1") : langText("home_btn_3")}</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      </Dialog>

      <Dialog
        closeable={!forceUpdate}
        width={"95%"}
        closeOnClickOverlay={!forceUpdate}
        visible={showUpdate}
        showCancelButton={!forceUpdate}
        showConfirmButton={AppVersion >= "1.0.9"}
        title={forceUpdate ? "Update Required" : "Update Ready"}
        onClose={() => {
          setShowUpdate(false);
        }}
        onConfirm={() => {
          location.href = "download://" + GetDownloadApkUrl(getPersist("channel") ? getPersist("channel") : "");
        }}
        confirmButtonText={"Download"}
        cancelButtonText={"Later"}
      >
        <div className={style.updateDialog}>
          {forceUpdate ? "You must update to the latest version to continue." : "Do you want to update now?"}
          {AppVersion < "1.0.9" && (
            <div style={{ width: "100%" }}>
              DownloadUrl:
              <CopyToClipboard
                text={GetDownloadApkUrl(getPersist("channel") ? getPersist("channel") : "")}
                onCopy={() => {
                  Toast.success({
                    message: "Copy Successfully",
                  });
                }}
              >
                <div>
                  <span style={{ color: "blue" }}>{GetDownloadApkUrl(getPersist("channel") ? getPersist("channel") : "")}</span>
                  <img
                    style={{
                      width: "1rem",
                      height: "1rem",
                      margin: "0 0 0 .5rem",
                      backgroundColor: "#000",
                      padding: "0.5rem",
                      borderRadius: "0.5rem",
                    }}
                    src={require("@/assets/icons/copy.png").default}
                    loading="lazy"
                  />
                </div>
              </CopyToClipboard>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default Home;
